module.exports = __webpack_public_path__ + "static/educative-code-running-f93e0b545f8744383c5adbf9984bdc31.webm";